import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { API_URL } from "../../config/config";
import { IoMdArrowRoundBack, IoMdArrowRoundForward } from "react-icons/io";

import "./viewImageModal.scss";

const ViewImagesModal = ({
    modal,
    setShowImageModal,
    imageIDs,
    setModalImageId,
    imagesArr,
}) => {
    return (
        <div>
            <Modal isOpen={modal} size="xl" centered fullscreen={"xl"} backdrop>
                <div className="relative w-100">
                    <span
                        onClick={() => setShowImageModal((prev) => !prev)}
                        title="Close Modal"
                        className="closeModal"
                    >
                        X
                    </span>
                </div>
                <ModalBody>
                    <div className="relative">
                        {imagesArr?.indexOf(imageIDs) > 0 && (
                            <span
                                className="prev"
                                title="Prev Image"
                                onClick={() =>
                                    setModalImageId(imagesArr[imagesArr?.indexOf(imageIDs) - 1])
                                }
                            >
                                <IoMdArrowRoundBack size={24} />
                            </span>
                        )}
                        <img
                            src={`${API_URL}/api/mkm/getimage/${imageIDs}`}
                            alt={`mkmImageId-${imageIDs}`}
                            style={{ height: "85vh" }}
                            className="w-100"
                        />
                        {imagesArr?.length - 1 > imagesArr?.indexOf(imageIDs) && (
                            <span
                                className="next"
                                title="Next Image"
                                onClick={() =>
                                    setModalImageId(imagesArr[imagesArr?.indexOf(imageIDs) + 1])
                                }
                            >
                                
                                <IoMdArrowRoundForward size={24} />
                            </span>
                        )}
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default ViewImagesModal;
